import { render, staticRenderFns } from "./PaginationCustom.vue?vue&type=template&id=9f0f721c"
import script from "./PaginationCustom.vue?vue&type=script&lang=js"
export * from "./PaginationCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports